import useReveal from '../../hooks/useReveal';

const HOME_WHY_COOWN_IMG =
  "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=600&h=750&fit=crop";

const HomeWhyCoownSection = () => {
  const [ref, visible] = useReveal();

  const features = [
    { icon: "fa-shield-halved", title: "Institutional-Grade Vetting", desc: "Every property undergoes 200+ point due diligence" },
    { icon: "fa-link", title: "Tokenized Ownership", desc: "Eligible properties issue on-chain share tokens (ASA) to your embedded Algorand wallet after legal clearance" },
    { icon: "fa-coins", title: "Fiat + Crypto Checkout", desc: "Invest with card-funded USD balance or pay with USDC/ALGO — settled in USD before shares are issued" },
    { icon: "fa-handshake", title: "Secondary Market", desc: "Sell your shares anytime to other investors" },
  ];

  return (
    <section ref={ref} className="home-why-coown" aria-labelledby="home-why-heading">
      <div className="home-why-coown-inner">
        <div>
          <div className={`reveal-up ${visible ? "visible" : ""} home-why-coown-eyebrow`}>
            <div className="home-why-coown-eyebrow-line"></div>
            <span className="home-why-coown-eyebrow-text">Why CoOwn</span>
          </div>
          <h2
            className={`reveal-up delay-1 ${visible ? "visible" : ""} home-why-coown-title`}
            id="home-why-heading"
          >
            The Future of<br /><em>Real Estate</em> Investing
          </h2>
          <p className={`reveal-up delay-2 ${visible ? "visible" : ""} home-why-coown-lead`}>
            We believe everyone deserves access to premium real estate. Our platform removes the traditional barriers — high capital requirements, management headaches, and liquidity constraints.
          </p>

          <div className="home-why-coown-features">
            {features.map((item, i) => (
              <div
                key={item.title}
                className={`reveal-up delay-${i + 2} ${visible ? "visible" : ""} home-why-coown-feature`}
              >
                <div className="home-why-coown-feature-icon" aria-hidden="true">
                  <i className={`fas ${item.icon}`}></i>
                </div>
                <div>
                  <h4 className="home-why-coown-feature-title">{item.title}</h4>
                  <p className="home-why-coown-feature-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={`reveal-up delay-2 ${visible ? "visible" : ""} home-why-coown-visual`}>
          <div className="home-why-coown-img-wrap">
            <img src={HOME_WHY_COOWN_IMG} alt="Luxury interior of a modern property" loading="lazy" />
          </div>
          <div className="home-why-coown-stat">
            <div className="home-why-coown-stat-header">
              <div className="home-why-coown-stat-icon" aria-hidden="true">
                <i className="fas fa-coins"></i>
              </div>
              <span className="home-why-coown-stat-label">Low Minimum</span>
            </div>
            <div className="home-why-coown-stat-value">From $500</div>
            <p className="home-why-coown-stat-sub">Start co-owning premium property</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeWhyCoownSection;
